import Vue from 'vue'
import Router from 'vue-router'
import Homezh from '../components/zh/home/home.vue'
import Profilezh from '../components/zh/profile/profile.vue'
import Gsjjzh from '../components/zh/profile/gsjj.vue'
import Alxwzh from '../components/zh/profile/alxw.vue'
import Xwxqzh from '../components/zh/profile/xwxq.vue'
import Productzh from '../components/zh/product/product.vue'
import Productsyzh from '../components/zh/product/productsy.vue'
import Ysjszh from '../components/zh/product/ysjs.vue'
import Lbzh from '../components/zh/product/lb.vue'
import Crqdzh from '../components/zh/product/crqd.vue'
import Kcpzh from '../components/zh/product/kcp.vue'
import Hhxtzh from '../components/zh/product/hhxt.vue'
import Xtghjzh from '../components/zh/product/xtghj.vue'
import Jsgzh from '../components/zh/product/jsg.vue'
import Ntzh from '../components/zh/product/nt.vue'
import Tszpzh from '../components/zh/product/tszp.vue'
import Lytkzh from '../components/zh/product/lytk.vue'
import Yjmzh from '../components/zh/product/yjm.vue'
import Yybjzh from '../components/zh/product/yybj.vue'
import Cytqwzh from '../components/zh/product/cytqw.vue'
import Chszh from '../components/zh/product/chs.vue'
import Ggtqwzh from '../components/zh/product/ggtqw.vue'
import Sfjtqwzh from '../components/zh/product/sfjtqw.vue'
import Ptztqwzh from '../components/zh/product/ptztqw.vue'
import Lsrgszh from '../components/zh/product/lsrgs.vue'
import Lsjyzh from '../components/zh/product/lsjy.vue'
import Ysyzh from '../components/zh/product/ysy.vue'
import Rjzh from '../components/zh/product/rj.vue'
import Laszh from '../components/zh/product/las.vue'
import Hgylzh from '../components/zh/product/hgyl.vue'
import Gtllzh from '../components/zh/product/gtll.vue'
import Jsmdzh from '../components/zh/product/jsmd.vue'
import Bxxzh from '../components/zh/product/bxx.vue'
import Contactzh from '../components/zh/contact/contact.vue'
import Bbszh from '../components/zh/bbs/bbs.vue'
import Devicezh from '../components/zh/device/device.vue'
import Devicesyzh from '../components/zh/device/devicesy.vue'
import Lglzzh from '../components/zh/device/lglz.vue'
import Ggsczh from '../components/zh/device/ggsc.vue'
import Gjsczh from '../components/zh/device/gjsc.vue'
import Gsplzh from '../components/zh/device/gspl.vue'
import Spfrzh from '../components/zh/device/spfr.vue'
import Xxzjzh from '../components/zh/device/xxzj.vue'
import Dkzjzh from '../components/zh/device/dkzj.vue'
import Lhlbzh from '../components/zh/device/lhlb.vue'
import Jyjjzh from '../components/zh/device/jyjj.vue'
import Zsthzh from '../components/zh/device/zsth.vue'
import Lxthzh from '../components/zh/device/lxth.vue'
import Jcjzh from '../components/zh/device/jcj.vue'
import Jcmjzh from '../components/zh/device/jcmj.vue'
import Zsmjzh from '../components/zh/device/zsmj.vue'
import Jtlgzh from '../components/zh/device/jtlg.vue'
import Dkzgzh from '../components/zh/device/dkzg.vue'
import Lxgpzh from '../components/zh/device/lxgp.vue'
import Investzh from '../components/zh/invest/invest.vue'
import Recruitzh from '../components/zh/recruit/recruit.vue'

import Homeen from '../components/en/home/home.vue'
import Profileen from '../components/en/profile/profile.vue'
import Gsjjen from '../components/en/profile/gsjj.vue'
import Alxwen from '../components/en/profile/alxw.vue'
import Xwxqen from '../components/en/profile/xwxq.vue'
import Producten from '../components/en/product/product.vue'
import Productsyen from '../components/en/product/productsy.vue'
import Ysjsen from '../components/en/product/ysjs.vue'
import Lben from '../components/en/product/lb.vue'
import Crqden from '../components/en/product/crqd.vue'
import Kcpen from '../components/en/product/kcp.vue'
import Hhxten from '../components/en/product/hhxt.vue'
import Xtghjen from '../components/en/product/xtghj.vue'
import Jsgen from '../components/en/product/jsg.vue'
import Nten from '../components/en/product/nt.vue'
import Tszpen from '../components/en/product/tszp.vue'
import Lytken from '../components/en/product/lytk.vue'
import Yjmen from '../components/en/product/yjm.vue'
import Yybjen from '../components/en/product/yybj.vue'
import Cytqwen from '../components/en/product/cytqw.vue'
import Chsen from '../components/en/product/chs.vue'
import Ggtqwen from '../components/en/product/ggtqw.vue'
import Sfjtqwen from '../components/en/product/sfjtqw.vue'
import Ptztqwen from '../components/en/product/ptztqw.vue'
import Lsrgsen from '../components/en/product/lsrgs.vue'
import Lsjyen from '../components/en/product/lsjy.vue'
import Ysyen from '../components/en/product/ysy.vue'
import Rjen from '../components/en/product/rj.vue'
import Lasen from '../components/en/product/las.vue'
import Hgylen from '../components/en/product/hgyl.vue'
import Gtllen from '../components/en/product/gtll.vue'
import Jsmden from '../components/en/product/jsmd.vue'
import Bxxen from '../components/en/product/bxx.vue'
import Contacten from '../components/en/contact/contact.vue'
import Bbsen from '../components/en/bbs/bbs.vue'
import Deviceen from '../components/en/device/device.vue'
import Devicesyen from '../components/en/device/devicesy.vue'
import Lglzen from '../components/en/device/lglz.vue'
import Ggscen from '../components/en/device/ggsc.vue'
import Gjscen from '../components/en/device/gjsc.vue'
import Gsplen from '../components/en/device/gspl.vue'
import Spfren from '../components/en/device/spfr.vue'
import Xxzjen from '../components/en/device/xxzj.vue'
import Dkzjen from '../components/en/device/dkzj.vue'
import Lhlben from '../components/en/device/lhlb.vue'
import Jyjjen from '../components/en/device/jyjj.vue'
import Zsthen from '../components/en/device/zsth.vue'
import Lxthen from '../components/en/device/lxth.vue'
import Jcjen from '../components/en/device/jcj.vue'
import Jcmjen from '../components/en/device/jcmj.vue'
import Zsmjen from '../components/en/device/zsmj.vue'
import Jtlgen from '../components/en/device/jtlg.vue'
import Dkzgen from '../components/en/device/dkzg.vue'
import Lxgpen from '../components/en/device/lxgp.vue'
import Investen from '../components/en/invest/invest.vue'
import Recruiten from '../components/en/recruit/recruit.vue'

import Homeew from '../components/ew/home/home.vue'
import Profileew from '../components/ew/profile/profile.vue'
import Gsjjew from '../components/ew/profile/gsjj.vue'
import Alxwew from '../components/ew/profile/alxw.vue'
import Xwxqew from '../components/ew/profile/xwxq.vue'
import Productew from '../components/ew/product/product.vue'
import Productsyew from '../components/ew/product/productsy.vue'
import Ysjsew from '../components/ew/product/ysjs.vue'
import Lbew from '../components/ew/product/lb.vue'
import Crqdew from '../components/ew/product/crqd.vue'
import Kcpew from '../components/ew/product/kcp.vue'
import Hhxtew from '../components/ew/product/hhxt.vue'
import Xtghjew from '../components/ew/product/xtghj.vue'
import Jsgew from '../components/ew/product/jsg.vue'
import Ntew from '../components/ew/product/nt.vue'
import Tszpew from '../components/ew/product/tszp.vue'
import Lytkew from '../components/ew/product/lytk.vue'
import Yjmew from '../components/ew/product/yjm.vue'
import Yybjew from '../components/ew/product/yybj.vue'
import Cytqwew from '../components/ew/product/cytqw.vue'
import Chsew from '../components/ew/product/chs.vue'
import Ggtqwew from '../components/ew/product/ggtqw.vue'
import Sfjtqwew from '../components/ew/product/sfjtqw.vue'
import Ptztqwew from '../components/ew/product/ptztqw.vue'
import Lsrgsew from '../components/ew/product/lsrgs.vue'
import Lsjyew from '../components/ew/product/lsjy.vue'
import Ysyew from '../components/ew/product/ysy.vue'
import Rjew from '../components/ew/product/rj.vue'
import Lasew from '../components/ew/product/las.vue'
import Hgylew from '../components/ew/product/hgyl.vue'
import Gtllew from '../components/ew/product/gtll.vue'
import Jsmdew from '../components/ew/product/jsmd.vue'
import Bxxew from '../components/ew/product/bxx.vue'
import Contactew from '../components/ew/contact/contact.vue'
import Bbsew from '../components/ew/bbs/bbs.vue'
import Deviceew from '../components/ew/device/device.vue'
import Devicesyew from '../components/ew/device/devicesy.vue'
import Lglzew from '../components/ew/device/lglz.vue'
import Ggscew from '../components/ew/device/ggsc.vue'
import Gjscew from '../components/ew/device/gjsc.vue'
import Gsplew from '../components/ew/device/gspl.vue'
import Spfrew from '../components/ew/device/spfr.vue'
import Xxzjew from '../components/ew/device/xxzj.vue'
import Dkzjew from '../components/ew/device/dkzj.vue'
import Lhlbew from '../components/ew/device/lhlb.vue'
import Jyjjew from '../components/ew/device/jyjj.vue'
import Zsthew from '../components/ew/device/zsth.vue'
import Lxthew from '../components/ew/device/lxth.vue'
import Jcjew from '../components/ew/device/jcj.vue'
import Jcmjew from '../components/ew/device/jcmj.vue'
import Zsmjew from '../components/ew/device/zsmj.vue'
import Jtlgew from '../components/ew/device/jtlg.vue'
import Dkzgew from '../components/ew/device/dkzg.vue'
import Lxgpew from '../components/ew/device/lxgp.vue'
import Investew from '../components/ew/invest/invest.vue'
import Recruitew from '../components/ew/recruit/recruit.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      redirect: '/homezh'
    },
    {
      path: '/homezh',
      component: Homezh
    },
    {
      path: '/profilezh',
      component: Profilezh,
      children: [{
          path: '/profilezh',
          redirect: '/profilezh/gsjjzh'
        },
        {
          path: '/profilezh/gsjjzh',
          component: Gsjjzh
        },
        {
          path: '/profilezh/alxwzh',
          component: Alxwzh
        },
        {
          path: '/profilezh/xwxqzh/:id',
          component: Xwxqzh
        }
      ]
    },
    {
      path: '/productzh',
      component: Productzh,
      children: [{
          path: '/productzh',
          redirect: '/productzh/productsyzh'
        },
        {
          path: '/productzh/productsyzh',
          component: Productsyzh
        },
        {
          path: '/productzh/ysjszh',
          component: Ysjszh
        },
        {
          path: '/productzh/kcpzh',
          component: Kcpzh
        },
        {
          path: '/productzh/tszpzh',
          component: Tszpzh
        },
        {
          path: '/productzh/yybjzh',
          component: Yybjzh
        },
        {
          path: '/productzh/hgylzh',
          component: Hgylzh
        },
        {
          path: '/productzh/lbzh',
          component: Lbzh
        },
        {
          path: '/productzh/crqdzh',
          component: Crqdzh
        },
        {
          path: '/productzh/hhxtzh',
          component: Hhxtzh
        },
        {
          path: '/productzh/xtghjzh',
          component: Xtghjzh
        },
        {
          path: '/productzh/jsgzh',
          component: Jsgzh
        },
        {
          path: '/productzh/ntzh',
          component: Ntzh
        },
        {
          path: '/productzh/lytkzh',
          component: Lytkzh
        },
        {
          path: '/productzh/yjmzh',
          component: Yjmzh
        },
        {
          path: '/productzh/cytqwzh',
          component: Cytqwzh
        },
        {
          path: '/productzh/chszh',
          component: Chszh
        },
        {
          path: '/productzh/ggtqwzh',
          component: Ggtqwzh
        },
        {
          path: '/productzh/sfjtqwzh',
          component: Sfjtqwzh
        },
        {
          path: '/productzh/ptztqwzh',
          component: Ptztqwzh
        },
        {
          path: '/productzh/lsrgszh',
          component: Lsrgszh
        },
        {
          path: '/productzh/lsjyzh',
          component: Lsjyzh
        },
        {
          path: '/productzh/ysyzh',
          component: Ysyzh
        },
        {
          path: '/productzh/rjzh',
          component: Rjzh
        },
        {
          path: '/productzh/laszh',
          component: Laszh
        },
        {
          path: '/productzh/hgylzh',
          component: Hgylzh
        },
        {
          path: '/productzh/gtllzh',
          component: Gtllzh
        },
        {
          path: '/productzh/jsmdzh',
          component: Jsmdzh
        },
        {
          path: '/productzh/bxxzh',
          component: Bxxzh
        }
      ]
    },
    {
      path: '/contactzh',
      component: Contactzh
    },
    {
      path: '/bbszh',
      component: Bbszh
    },
    {
      path: '/devicezh',
      component: Devicezh,
      children: [{
          path: '/devicezh',
          redirect: '/devicezh/devicesyzh'
        },
        {
          path: '/devicezh/devicesyzh',
          component: Devicesyzh
        },
        {
          path: '/devicezh/lglzzh',
          component: Lglzzh
        },
        {
          path: '/devicezh/ggsczh',
          component: Ggsczh
        },
        {
          path: '/devicezh/gjsczh',
          component: Gjsczh
        },
        {
          path: '/devicezh/gsplzh',
          component: Gsplzh
        },
        {
          path: '/devicezh/devicesyzh',
          component: Devicesyzh
        },
        {
          path: '/devicezh/devicesyzh',
          component: Devicesyzh
        },
        {
          path: '/devicezh/spfrzh',
          component: Spfrzh
        },
        {
          path: '/devicezh/xxzjzh',
          component: Xxzjzh
        },
        {
          path: '/devicezh/dkzjzh',
          component: Dkzjzh
        },
        {
          path: '/devicezh/lhlbzh',
          component: Lhlbzh
        },
        {
          path: '/devicezh/jyjjzh',
          component: Jyjjzh
        },
        {
          path: '/devicezh/zsthzh',
          component: Zsthzh
        },
        {
          path: '/devicezh/lxthzh',
          component: Lxthzh
        },
        {
          path: '/devicezh/jcjzh',
          component: Jcjzh
        },
        {
          path: '/devicezh/Jcmjzh',
          component: Jcmjzh
        },
        {
          path: '/devicezh/zsmjzh',
          component: Zsmjzh
        },
        {
          path: '/devicezh/jtlgzh',
          component: Jtlgzh
        },
        {
          path: '/devicezh/dkzgzh',
          component: Dkzgzh
        },
        {
          path: '/devicezh/lxgpzh',
          component: Lxgpzh
        }
      ]
    },
    {
      path: '/investzh',
      component: Investzh
    },
    {
      path: '/recruitzh',
      component: Recruitzh
    },
    {
      path: '/homeen',
      component: Homeen
    },
    {
      path: '/profileen',
      component: Profileen,
      children: [{
          path: '/profileen',
          redirect: '/profileen/gsjjen'
        },
        {
          path: '/profileen/gsjjen',
          component: Gsjjen
        },
        {
          path: '/profileen/alxwen',
          component: Alxwen
        },
        {
          path: '/profileen/xwxqen/:id',
          component: Xwxqen
        }
      ]
    },
    {
      path: '/producten',
      component: Producten,
      children: [{
          path: '/producten',
          redirect: '/producten/productsyen'
        },
        {
          path: '/producten/productsyen',
          component: Productsyen
        },
        {
          path: '/producten/ysjsen',
          component: Ysjsen
        },
        {
          path: '/producten/kcpen',
          component: Kcpen
        },
        {
          path: '/producten/tszpen',
          component: Tszpen
        },
        {
          path: '/producten/yybjen',
          component: Yybjen
        },
        {
          path: '/producten/hgylen',
          component: Hgylen
        },
        {
          path: '/producten/lben',
          component: Lben
        },
        {
          path: '/producten/crqden',
          component: Crqden
        },
        {
          path: '/producten/hhxten',
          component: Hhxten
        },
        {
          path: '/producten/xtghjen',
          component: Xtghjen
        },
        {
          path: '/producten/jsgen',
          component: Jsgen
        },
        {
          path: '/producten/nten',
          component: Nten
        },
        {
          path: '/producten/lytken',
          component: Lytken
        },
        {
          path: '/producten/yjmen',
          component: Yjmen
        },
        {
          path: '/producten/cytqwen',
          component: Cytqwen
        },
        {
          path: '/producten/chsen',
          component: Chsen
        },
        {
          path: '/producten/ggtqwen',
          component: Ggtqwen
        },
        {
          path: '/producten/sfjtqwen',
          component: Sfjtqwen
        },
        {
          path: '/producten/ptztqwen',
          component: Ptztqwen
        },
        {
          path: '/producten/lsrgsen',
          component: Lsrgsen
        },
        {
          path: '/producten/lsjyen',
          component: Lsjyen
        },
        {
          path: '/producten/ysyen',
          component: Ysyen
        },
        {
          path: '/producten/rjen',
          component: Rjen
        },
        {
          path: '/producten/lasen',
          component: Lasen
        },
        {
          path: '/producten/hgylen',
          component: Hgylen
        },
        {
          path: '/producten/gtllen',
          component: Gtllen
        },
        {
          path: '/producten/jsmden',
          component: Jsmden
        },
        {
          path: '/producten/bxxen',
          component: Bxxen
        }
      ]
    },
    {
      path: '/contacten',
      component: Contacten
    },
    {
      path: '/bbsen',
      component: Bbsen
    },
    {
      path: '/deviceen',
      component: Deviceen,
      children: [{
          path: '/deviceen',
          redirect: '/deviceen/devicesyen'
        },
        {
          path: '/deviceen/devicesyen',
          component: Devicesyen
        },
        {
          path: '/deviceen/lglzen',
          component: Lglzen
        },
        {
          path: '/deviceen/ggscen',
          component: Ggscen
        },
        {
          path: '/deviceen/gjscen',
          component: Gjscen
        },
        {
          path: '/deviceen/gsplen',
          component: Gsplen
        },
        {
          path: '/deviceen/devicesyen',
          component: Devicesyen
        },
        {
          path: '/deviceen/devicesyen',
          component: Devicesyen
        },
        {
          path: '/deviceen/spfren',
          component: Spfren
        },
        {
          path: '/deviceen/xxzjen',
          component: Xxzjen
        },
        {
          path: '/deviceen/dkzjen',
          component: Dkzjen
        },
        {
          path: '/deviceen/lhlben',
          component: Lhlben
        },
        {
          path: '/deviceen/jyjjen',
          component: Jyjjen
        },
        {
          path: '/deviceen/zsthen',
          component: Zsthen
        },
        {
          path: '/deviceen/lxthen',
          component: Lxthen
        },
        {
          path: '/deviceen/jcjen',
          component: Jcjen
        },
        {
          path: '/deviceen/Jcmjen',
          component: Jcmjen
        },
        {
          path: '/deviceen/zsmjen',
          component: Zsmjen
        },
        {
          path: '/deviceen/jtlgen',
          component: Jtlgen
        },
        {
          path: '/deviceen/dkzgen',
          component: Dkzgen
        },
        {
          path: '/deviceen/lxgpen',
          component: Lxgpen
        }
      ]
    },
    {
      path: '/investen',
      component: Investen
    },
    {
      path: '/recruiten',
      component: Recruiten
    },
    {
      path: '/homeew',
      component: Homeew
    },
    {
      path: '/profileew',
      component: Profileew,
      children: [{
          path: '/profileew',
          redirect: '/profileew/gsjjew'
        },
        {
          path: '/profileew/gsjjew',
          component: Gsjjew
        },
        {
          path: '/profileew/alxwew',
          component: Alxwew
        },
        {
          path: '/profileew/xwxqew/:id',
          component: Xwxqew
        }
      ]
    },
    {
      path: '/productew',
      component: Productew,
      children: [{
          path: '/productew',
          redirect: '/productew/productsyew'
        },
        {
          path: '/productew/productsyew',
          component: Productsyew
        },
        {
          path: '/productew/ysjsew',
          component: Ysjsew
        },
        {
          path: '/productew/kcpew',
          component: Kcpew
        },
        {
          path: '/productew/tszpew',
          component: Tszpew
        },
        {
          path: '/productew/yybjew',
          component: Yybjew
        },
        {
          path: '/productew/hgylew',
          component: Hgylew
        },
        {
          path: '/productew/lbew',
          component: Lbew
        },
        {
          path: '/productew/crqdew',
          component: Crqdew
        },
        {
          path: '/productew/hhxtew',
          component: Hhxtew
        },
        {
          path: '/productew/xtghjew',
          component: Xtghjew
        },
        {
          path: '/productew/jsgew',
          component: Jsgew
        },
        {
          path: '/productew/ntew',
          component: Ntew
        },
        {
          path: '/productew/lytkew',
          component: Lytkew
        },
        {
          path: '/productew/yjmew',
          component: Yjmew
        },
        {
          path: '/productew/cytqwew',
          component: Cytqwew
        },
        {
          path: '/productew/chsew',
          component: Chsew
        },
        {
          path: '/productew/ggtqwew',
          component: Ggtqwew
        },
        {
          path: '/productew/sfjtqwew',
          component: Sfjtqwew
        },
        {
          path: '/productew/ptztqwew',
          component: Ptztqwew
        },
        {
          path: '/productew/lsrgsew',
          component: Lsrgsew
        },
        {
          path: '/productew/lsjyew',
          component: Lsjyew
        },
        {
          path: '/productew/ysyew',
          component: Ysyew
        },
        {
          path: '/productew/rjew',
          component: Rjew
        },
        {
          path: '/productew/lasew',
          component: Lasew
        },
        {
          path: '/productew/hgylew',
          component: Hgylew
        },
        {
          path: '/productew/gtllew',
          component: Gtllew
        },
        {
          path: '/productew/jsmdew',
          component: Jsmdew
        },
        {
          path: '/productew/bxxew',
          component: Bxxew
        }
      ]
    },
    {
      path: '/contactew',
      component: Contactew
    },
    {
      path: '/bbsew',
      component: Bbsew
    },
    {
      path: '/deviceew',
      component: Deviceew,
      children: [{
          path: '/deviceew',
          redirect: '/deviceew/devicesyew'
        },
        {
          path: '/deviceew/devicesyew',
          component: Devicesyew
        },
        {
          path: '/deviceew/lglzew',
          component: Lglzew
        },
        {
          path: '/deviceew/ggscew',
          component: Ggscew
        },
        {
          path: '/deviceew/gjscew',
          component: Gjscew
        },
        {
          path: '/deviceew/gsplew',
          component: Gsplew
        },
        {
          path: '/deviceew/devicesyew',
          component: Devicesyew
        },
        {
          path: '/deviceew/devicesyew',
          component: Devicesyew
        },
        {
          path: '/deviceew/spfrew',
          component: Spfrew
        },
        {
          path: '/deviceew/xxzjew',
          component: Xxzjew
        },
        {
          path: '/deviceew/dkzjew',
          component: Dkzjew
        },
        {
          path: '/deviceew/lhlbew',
          component: Lhlbew
        },
        {
          path: '/deviceew/jyjjew',
          component: Jyjjew
        },
        {
          path: '/deviceew/zsthew',
          component: Zsthew
        },
        {
          path: '/deviceew/lxthew',
          component: Lxthew
        },
        {
          path: '/deviceew/jcjew',
          component: Jcjew
        },
        {
          path: '/deviceew/Jcmjew',
          component: Jcmjew
        },
        {
          path: '/deviceew/zsmjew',
          component: Zsmjew
        },
        {
          path: '/deviceew/jtlgew',
          component: Jtlgew
        },
        {
          path: '/deviceew/dkzgew',
          component: Dkzgew
        },
        {
          path: '/deviceew/lxgpew',
          component: Lxgpew
        }
      ]
    },
    {
      path: '/investew',
      component: Investew
    },
    {
      path: '/recruitew',
      component: Recruitew
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js